import { render, staticRenderFns } from "./SelectPersona.vue?vue&type=template&id=c2936986"
import script from "./SelectPersona.vue?vue&type=script&lang=js"
export * from "./SelectPersona.vue?vue&type=script&lang=js"
import style0 from "./SelectPersona.vue?vue&type=style&index=0&id=c2936986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports